import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	gap: 0.3em;
	top: 0.5em;
	z-index: 1;
`;

export const ButtonTab = styled.a`
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	width: 7.2em;
	height: 2.4em;
	border-radius: 3.2em;
	border: 0.2em solid #ffc38d;
	background: linear-gradient(180deg, #f3fdff 0.36%, #ffe4c5 99.64%);
	box-shadow: 0 0.05em 0.2em 0.2em rgba(0, 0, 0, 0.5) inset,
		0 0.3em 0.75em 0 rgba(0, 0, 0, 0.15);
	color: #113b62;
	paint-order: stroke fill;
	-webkit-text-stroke-width: 0.2em;
	-webkit-text-stroke-color: #fff;
	font-family: "Baloo";
	font-size: 1.25em;
	font-style: normal;
	font-weight: 400;
	line-height: 100%;

	&.active {
		background: linear-gradient(180deg, #7ee6ff 0.36%, #35c0ee 99.64%);
	}
`;
